module.exports = __webpack_public_path__ + "images/airtm.f36a48c096cf71ec452498a25009c023.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/logos/airtm.png
// module id = 1012
// module chunks = 0